import cookieConstants from '../constants/CookieConstants';

function accept() {
  return {
    type: cookieConstants.ACCEPTED,
  };
}

export default accept;
